import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectCompatiblePapersOptionsForSize } from '../../../../_redux-papers';
import { selectSizesOptionsForPaper } from '../../../../_redux-sizes';
import { overwritePaperSelectionIfIncompatible } from '../../../../helpers/overwritePaperSelectionIfIncompatible';
import { updateVariant } from '../../../../thunks/updateVariant';
import { VariantOption } from '../../../../VariantOption';
import { VariantDropdown } from './VariantDropdown';
import styles from './VariantDropdownGroup.module.scss';

const _VariantDropdowns = ({
    activeVariant,
    paperOptions, sizeOptions,
    updateVariant
}: Props) => {

    const onSizeChange = useCallback((newSizeId: string) => {
        const paperId = overwritePaperSelectionIfIncompatible(activeVariant.paperId, newSizeId, paperOptions);
        updateVariant(paperId, newSizeId);
    }, [activeVariant, paperOptions, updateVariant]);

    const onPaperChange = (paperId: string) => {
        updateVariant(paperId, activeVariant.sizeId);
    };

    return (
        <Grid wrap gap='s'>
            <Cell className={styles.cell}>
                <VariantDropdown value={activeVariant.sizeId}
                    onChange={onSizeChange}
                    options={sizeOptions} />
            </Cell>
            {paperOptions.length > 1 && (
                <Cell className={styles.cell}>
                    <VariantDropdown value={activeVariant.paperId}
                        onChange={onPaperChange}
                        options={paperOptions} />
                </Cell>
            )}
        </Grid>
    );
};

type OwnProps = {
    groupId: string;
    activeVariant: PhotoPrintsJson.Variant;
};

type Props = OwnProps & {
    paperOptions: VariantOption[];
    sizeOptions: VariantOption[];
    updateVariant: (paperId: string | undefined, sizeId: string | undefined) => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    paperOptions: selectCompatiblePapersOptionsForSize(state, ownProps.activeVariant.sizeId),
    sizeOptions: selectSizesOptionsForPaper(state, ownProps.activeVariant.paperId)
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    updateVariant: (paperId: string | undefined, sizeId: string | undefined) => {
        dispatch(updateVariant(paperId, sizeId, ownProps.groupId));
    }
});

export const VariantDropdownGroup = connect(
    mapStateToProps,
    mapDispatchToProps
)(_VariantDropdowns);